export const BACK = 'back';
export const FINISH = 'finish';
export const NEXT = 'next';
export const DONE_STEP = 'done';